// extracted by mini-css-extract-plugin
export default {"login":"login_login__jYuYf","paper":"login_paper__FGj+t","form":"login_form__2L96z"};